module.exports = __webpack_public_path__ + "img/ClickForSound_33.da75dfcf.png";